import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import { useTranslation } from "@coworker/locales";
import { PlacementsText } from "./PlacementsText";
import { MediasAndArticleCountResponse } from "../types/media";

interface MediaPlacementProps {
  mediasArticleCount: MediasAndArticleCountResponse[];
  currentArticleId?: string | undefined;
}

export function MediaPlacement({
  currentArticleId,
  mediasArticleCount,
}: MediaPlacementProps) {
  const { t } = useTranslation();

  const addOnContent = (
    <PlacementsText
      currentArticleId={currentArticleId || ""}
      mediasArticleCount={mediasArticleCount}
    />
  );

  return (
    <FixaListViewItem
      title={t("mediaPlacementsString")}
      addOn={addOnContent}
      emphasised
      inset
    />
  );
}
